import api from '../store/apiClient';

export const collectionService = {
  /** @returns {Promise<object[]>} */
  async list() {
    const { data } = await api.get('/collections');
    const list = data?.data ?? data ?? [];
    return Array.isArray(list) ? list : [];
  },

  /** Collection document + populated `products` array */
  async getBySlug(slug, locale) {
    const params = {};
    if (locale && String(locale).trim()) params.locale = String(locale).trim();
    const { data } = await api.get(`/collections/${encodeURIComponent(slug)}`, { params });
    return data?.data ?? data;
  },
};
